import http from '../_http'

const admin = {
  //default
  summaryAdmin : (m) => { return http.get('manager/management/admin', m); },
  listAdmin : (m) => { return http.post('manager/management/admin/list', m); },
  detailAdmin : (m) => { return http.get(`manager/management/admin/${m.id}`); },

  //crud
  insertAdmin : (m) => { return http.post('manager/management/admin', m); },
  updateAdmin : (m) => { return http.put('manager/management/admin', m); },
  deleteAdmin : (m) => { return http.delete(`manager/management/admin/${m.id}`); },
  resetAdmin : (m) => { return http.get(`manager/management/admin/reset/${m.id}`);}
}

export default admin

export { admin }